import React, { useState } from 'react';
import { useStore, CustomerAccount } from '../../context/StoreContext';
import { Search, MapPin, X, Mail, Phone } from 'lucide-react';
export function AdminCustomers() {
  const {
    customers,
    orders
  } = useStore();
  const [search, setSearch] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState<CustomerAccount | null>(null);
  const filteredCustomers = customers.filter(c => c.firstName.toLowerCase().includes(search.toLowerCase()) || c.lastName.toLowerCase().includes(search.toLowerCase()) || c.email.toLowerCase().includes(search.toLowerCase()));
  return <div className="space-y-6" data-id="element-400">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-401">
        <h1 className="text-2xl font-extrabold text-gray-900" data-id="element-402">Customers</h1>
        <div className="relative" data-id="element-403">
          <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-404" />
          <input type="text" placeholder="Search customers..." value={search} onChange={e => setSearch(e.target.value)} className="pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-yarbo-dark focus:border-transparent w-full sm:w-64" data-id="element-405" />
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-406">
        <div className="overflow-x-auto" data-id="element-407">
          <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-408">
            <thead className="bg-gray-50 text-gray-500 font-medium" data-id="element-409">
              <tr data-id="element-410">
                <th className="px-6 py-4" data-id="element-411">Customer</th>
                <th className="px-6 py-4" data-id="element-412">Contact</th>
                <th className="px-6 py-4" data-id="element-413">Orders</th>
                <th className="px-6 py-4" data-id="element-414">Total Spent</th>
                <th className="px-6 py-4" data-id="element-415">Location</th>
                <th className="px-6 py-4 text-right" data-id="element-416">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-417">
              {filteredCustomers.map(customer => {
              const customerOrders = orders.filter(o => o.customer.email.toLowerCase() === customer.email.toLowerCase());
              const totalSpent = customerOrders.reduce((sum, order) => {
                return sum + order.items.reduce((s, item) => s + item.unitPrice * item.qty + (item.protection?.price || 0), 0) + order.shippingCost + order.tax;
              }, 0);
              return <tr key={customer.id} className="hover:bg-gray-50" data-id="element-418">
                    <td className="px-6 py-4" data-id="element-419">
                      <div className="font-bold text-gray-900" data-id="element-420">
                        {customer.firstName} {customer.lastName}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-421">
                        ID: {customer.id}
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-422">
                      <div className="text-gray-900" data-id="element-423">{customer.email}</div>
                      <div className="text-xs text-gray-500" data-id="element-424">
                        {customer.phone || 'No phone'}
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-425">
                      <div className="flex items-center gap-1 text-gray-900" data-id="element-426">
                        <Package className="w-4 h-4 text-gray-400" data-id="element-427" />{' '}
                        {customerOrders.length}
                      </div>
                    </td>
                    <td className="px-6 py-4 font-medium text-gray-900" data-id="element-428">
                      $
                      {totalSpent.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                    </td>
                    <td className="px-6 py-4" data-id="element-429">
                      {customer.addresses.length > 0 ? <div className="flex items-center gap-1 text-gray-600 text-xs" data-id="element-430">
                          <MapPin className="w-3 h-3" data-id="element-431" />{' '}
                          {customer.addresses[0].city},{' '}
                          {customer.addresses[0].state}
                        </div> : <span className="text-gray-400 text-xs" data-id="element-432">
                          No address
                        </span>}
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-433">
                      <button onClick={() => setSelectedCustomer(customer)} className="text-yarbo-dark font-bold hover:underline" data-id="element-434">
                        View
                      </button>
                    </td>
                  </tr>;
            })}
              {filteredCustomers.length === 0 && <tr data-id="element-435">
                  <td colSpan={6} className="px-6 py-12 text-center text-gray-500" data-id="element-436">
                    No customers found.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>

      {/* Customer Detail Modal */}
      {selectedCustomer && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-gray-900/50 backdrop-blur-sm" data-id="element-437">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden" data-id="element-438">
            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gray-50" data-id="element-439">
              <div data-id="element-440">
                <h2 className="text-xl font-extrabold text-gray-900" data-id="element-441">
                  {selectedCustomer.firstName} {selectedCustomer.lastName}
                </h2>
                <p className="text-sm text-gray-500" data-id="element-442">
                  Customer ID: {selectedCustomer.id}
                </p>
              </div>
              <button onClick={() => setSelectedCustomer(null)} className="text-gray-400 hover:text-gray-600" data-id="element-443">
                <X className="w-6 h-6" data-id="element-444" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6" data-id="element-445">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-446">
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-447">
                  <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3" data-id="element-448">
                    Contact Info
                  </h3>
                  <div className="space-y-2 text-sm" data-id="element-449">
                    <div className="flex items-center gap-2 text-gray-700" data-id="element-450">
                      <Mail className="w-4 h-4 text-gray-400" data-id="element-451" />
                      <a href={`mailto:${selectedCustomer.email}`} className="hover:text-yarbo-dark hover:underline" data-id="element-452">
                        {selectedCustomer.email}
                      </a>
                    </div>
                    <div className="flex items-center gap-2 text-gray-700" data-id="element-453">
                      <Phone className="w-4 h-4 text-gray-400" data-id="element-454" />
                      {selectedCustomer.phone || <span className="text-gray-400 italic" data-id="element-455">No phone</span>}
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-456">
                  <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3" data-id="element-457">
                    Addresses
                  </h3>
                  {selectedCustomer.addresses.length > 0 ? <div className="space-y-3" data-id="element-458">
                      {selectedCustomer.addresses.map((addr, idx) => <div key={idx} className="text-sm text-gray-700 flex items-start gap-2" data-id="element-459">
                          <MapPin className="w-4 h-4 text-gray-400 shrink-0 mt-0.5" data-id="element-460" />
                          <div data-id="element-461">
                            {addr.line1}
                            <br data-id="element-462" />
                            {addr.line2 && <>
                                {addr.line2}
                                <br data-id="element-463" />
                              </>}
                            {addr.city}, {addr.state} {addr.zip}
                            <br data-id="element-464" />
                            {addr.country}
                          </div>
                        </div>)}
                    </div> : <p className="text-sm text-gray-400 italic" data-id="element-465">
                      No addresses saved.
                    </p>}
                </div>

                <div className="bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-466">
                  <h3 className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3" data-id="element-467">
                    Customer Summary
                  </h3>
                  <div className="space-y-2 text-sm text-gray-700" data-id="element-468">
                    <div className="flex justify-between" data-id="element-469">
                      <span className="text-gray-500" data-id="element-470">Total Orders:</span>
                      <span className="font-medium" data-id="element-471">
                        {orders.filter(o => o.customer.email.toLowerCase() === selectedCustomer.email.toLowerCase()).length}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-472">
                      <span className="text-gray-500" data-id="element-473">Total Spent:</span>
                      <span className="font-medium" data-id="element-474">
                        $
                        {orders.filter(o => o.customer.email.toLowerCase() === selectedCustomer.email.toLowerCase()).reduce((sum, order) => {
                      return sum + (order.subtotalAfterDiscount !== undefined ? order.subtotalAfterDiscount + order.shippingCost + order.tax : order.items.reduce((s, i) => s + i.unitPrice * i.qty + (i.protection?.price || 0), 0) + order.shippingCost + order.tax);
                    }, 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-475">
                Order History
              </h3>
              <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-476">
                <table className="w-full text-left text-sm" data-id="element-477">
                  <thead className="bg-gray-50 text-gray-500 font-medium" data-id="element-478">
                    <tr data-id="element-479">
                      <th className="px-4 py-3" data-id="element-480">Order</th>
                      <th className="px-4 py-3" data-id="element-481">Date</th>
                      <th className="px-4 py-3" data-id="element-482">Status</th>
                      <th className="px-4 py-3 text-right" data-id="element-483">Total</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-484">
                    {orders.filter(o => o.customer.email.toLowerCase() === selectedCustomer.email.toLowerCase()).map(order => <tr key={order.id} className="hover:bg-gray-50" data-id="element-485">
                          <td className="px-4 py-3 font-medium text-yarbo-dark" data-id="element-486">
                            {order.id}
                          </td>
                          <td className="px-4 py-3 text-gray-500" data-id="element-487">
                            {new Date(order.placedAt).toLocaleDateString()}
                          </td>
                          <td className="px-4 py-3 capitalize" data-id="element-488">
                            {order.status}
                          </td>
                          <td className="px-4 py-3 text-right font-medium" data-id="element-489">
                            $
                            {(order.subtotalAfterDiscount !== undefined ? order.subtotalAfterDiscount + order.shippingCost + order.tax : order.items.reduce((s, i) => s + i.unitPrice * i.qty + (i.protection?.price || 0), 0) + order.shippingCost + order.tax).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                          </td>
                        </tr>)}
                    {orders.filter(o => o.customer.email.toLowerCase() === selectedCustomer.email.toLowerCase()).length === 0 && <tr data-id="element-490">
                        <td colSpan={4} className="px-4 py-8 text-center text-gray-500" data-id="element-491">
                          No orders found for this customer.
                        </td>
                      </tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}